import { graphql } from 'gql.tada';
import { useMutation } from '@apollo/client';

const DeleteDraftInvoicesMutation = graphql.persisted(
  "DeleteDraftInvoices",
  graphql(`
    mutation DeleteDraftInvoices($familyEnrollmentId: ID!) {
      deleteDraftInvoices(input: { familyEnrollmentId: $familyEnrollmentId }) {
        familyEnrollment {
          id state
          invoices { id key status amountCents dueDate memo lineItems { id description amountCents lineType } }
        }
        deletedCount
        userErrors { message path }
      }
    }
  `)
);

export { DeleteDraftInvoicesMutation };

export function useDeleteDraftInvoices() {
  return useMutation(DeleteDraftInvoicesMutation);
}
